export const setQtyRange = numQty => {
  numQty.forEach((qty, i) => {
    if (qty === 0) {
      numQty.splice(i, 1)
    }
  })
  return numQty
}
